module.exports = __webpack_public_path__ + "static/media/carat-r-black.bad5e7f5.svg";